export default __webpack_public_path__ + "static/media/image.3759b08e.jpg";